import StandardProductTable from '@nerdwallet/react-product-table';
import {
  ROW,
  TEXTBOX,
  VERTICALSPACER,
  STANDARDPRODUCTTABLE,
  ABOUT,
  ABTESTWRAPPER,
  APPROW,
  AUDIOEMBED,
  ARTICLEHEROWRAPPER,
  AUTOINSURANCEENTRYPOINTWRAPPER,
  AUTOINSURANCEQUOTESWRAPPER,
  AWARDSBADGEDROPDOWN,
  AWARDSHERO,
  AWARDSHERO2023,
  AWARDSNAVIGATION,
  BACKTOTOP,
  AWARDTABLE,
  BOXTABLE,
  BORDERBANNER,
  BRANDHEADER,
  BRANDEDARTICLECALCULATOR,
  BRANDEDHERO,
  HORIZONTALBANNER,
  BULLETEDLIST,
  C3CHART,
  CALCULATOR,
  CATEGORYTILES,
  CDSPRODUCTTABLE,
  CDSFILTERS,
  CENTEREDHERO,
  CHARTSECTION,
  COLLAPSIBLEPARAGRAPH,
  CREDITCARDTABLE,
  CTABOX,
  DISCLOSURE,
  DIVIDER,
  EDITABLEBULLETEDLIST,
  EDITABLEFLOW,
  EDITABLEFLYOUTHEADER,
  EDITABLEINTERESTCALCULATOR,
  EDITABLELOGOSALAD,
  EDITABLEPANELGROUP,
  EDITABLEPRODUCTTABLE,
  EDITORCONTROL,
  EXPANDINGPRODUCTTABLE,
  FEATUREBAR,
  FEATUREDSTORY,
  FILTERS,
  FLEXCARD,
  FLEXCARDV2,
  GLOBALNAV,
  GRIDFORM,
  HEROLANDSCAPEVIDEO,
  HEROVIDEO,
  HOMEINSURANCEENTRYPOINTWRAPPER,
  ICONHEADER,
  IMAGE,
  IMAGECONTENT,
  INSURANCEPRODUCTCARDWRAPPER,
  INSURANCESTICKYWIDGET,
  INSURANCESUMMARYTABLEWRAPPER,
  JUMPLINKNAV,
  LABELEDC3CHART,
  LASTCHANCE,
  LASTUPDATE,
  LIFEINSURANCEQUOTESWRAPPER,
  MARKETPLACEPRODUCTCARD,
  NPSCRMEMAIL,
  PAGE,
  PARAGRAPH,
  PASSWORDLOCK,
  OURVALUES,
  QUERYPARAMMANAGER,
  QUERYPARAMSECTION,
  RENTERSINSURANCEENTRYPOINTWRAPPER,
  ROWTWOCOL,
  ROWTWOCOLOLD,
  SCREENSIZECONDITIONAL,
  SCROLLCONTROL,
  SPLASH,
  STANDARDHERO,
  STICKYHEADER,
  STORY,
  STORYBLOCK,
  STORYCARDS,
  STICKYCONTAINERWRAPPER,
  SWEEPSTAKESFORM,
  TERMSTABLE,
  THIRDPARTYEMBED,
  THREESTEPS,
  THREESTEPS2,
  TILECAROUSEL,
  TICKERTAPE,
  UNIVERSALBACKGROUNDIMAGE,
  UNIVERSALAUTHBUTTON,
  UNIVERSALBUTTON,
  UNIVERSALCONTAINER,
  UNIVERSALIMAGE,
  UNIVERSALMEDIA,
  UNIVERSALPRODUCTTABLE,
  UNIVERSALTEXT,
  VIDEOEMBED,
  ZIGZAG,
  MARKETPLACETHIRDPARTYEMBED,
} from './types';
import { NW_COMPONENTS } from './utils';

import Page from '../../components/page/page';
import Row from '../../components/row/row';
import TextBox from '../../components/text-box/text-box';
import VerticalSpacer from '../../components/vertical-spacer/vertical-spacer';
import About from '../../components/about/about';
import ABTestWrapper from '../../components/ab-test-wrapper/ab-test-wrapper';
import AppRow from '../../components/app-row/app-row';
import AudioEmbed from '../../components/audio-embed/audio-embed';
import ArticleHeroWrapper from '../../components/article-hero-wrapper/article-hero-wrapper';
import AutoInsuranceEntryPointWrapper from '../../components/auto-insurance-entry-point-wrapper/auto-insurance-entry-point-wrapper';
import AutoInsuranceQuotesWrapper from '../../components/auto-insurance-quotes-wrapper/auto-insurance-quotes-wrapper';
import AwardsBadgeDropdown from '../../components/awards-badge-dropdown/awards-badge-dropdown';
import AwardsHero from '../../components/awards-hero/awards-hero';
import AwardsHero2023 from '../../components/awards-hero-2023/awards-hero-2023';
import AwardsNavigation from '../../components/awards-navigation/awards-navigation';
import BackToTop from '../../components/back-to-top/back-to-top';
import AwardTable from '../../components/award-table/award-table';
import BoxTable from '../../components/box-table/box-table';
import BorderBanner from '../../components/border-banner/border-banner';
import BrandHeader from '../../components/brand-header/brand-header';
import BrandedArticleCalculator from '../../components/branded-article-calculator/branded-article-calculator';
import BrandedHero from '../../components/branded-hero/branded-hero';
import BulletedList from '../../components/bulleted-list/bulleted-list';
import C3Chart from '../../components/c3-chart/c3-chart';
import Calculator from '../../components/calculator/calculator';
import CategoryTiles from '../../components/category-tiles/category-tiles';
import CdsProductTable from '../../components/cds-product-table/cds-product-table';
import CdsFilters from '../../components/cds-filters/cds-filters';
import CenteredHero from '../../components/centered-hero/centered-hero';
import ChartSection from '../../components/chart-section/chart-section';
import CollapsibleParagraph from '../../components/collapsible-paragraph/collapsible-paragraph';
import CreditCardTable from '../../components/credit-card-table/credit-card-table';
import CtaBox from '../../components/cta-box/cta-box';
import Disclosure from '../../components/disclosure/disclosure';
import Divider from '../../components/divider/divider';
import EditableBulletedList from '../../components/editable-bulleted-list/editable-bulleted-list';
import EditableFlow from '../../components/editable-flow/editable-flow';
import EditableFlyOutHeader from '../../components/editable-fly-out-header/editable-fly-out-header';
import EditableInterestCalculator from '../../components/editable-interest-calculator/editable-interest-calculator';
import EditableLogoSalad from '../../components/logo-salad/editable-logo-salad';
import EditablePanelGroup from '../../components/editable-panel-group/editable-panel-group';
import EditableProductTable from '../../components/editable-product-table/editable-product-table';
import EditorControl from '../../containers/editor-control/editor-control';
import ExpandingProductTable from '../../components/expanding-product-table/expanding-product-table';
import FeatureBar from '../../components/feature-bar/feature-bar';
import Filters from '../../components/filters/filters';
import FlexCard from '../../components/flex-card/flex-card';
import FlexCardV2 from '../../components/flex-card-v2/flex-card-v2';
import FeaturedStory from '../../components/featured-story/featured-story';
import GlobalNav from '../../components/global-nav/global-nav';
import GridForm from '../../components/grid-form/grid-form';
import HeroLandscapeVideo from '../../components/hero-landscape-video/hero-landscape-video';
import HeroVideo from '../../components/hero-video/hero-video';
import HomeInsuranceEntryPointWrapper from '../../components/home-insurance-entry-point-wrapper/home-insurance-entry-point-wrapper';
import HorizontalBanner from '../../components/horizontal-banner/horizontal-banner';
import IconHeader from '../../components/icon-header/icon-header';
import Image from '../../components/image/image';
import InsuranceProductCardWrapper from '../../components/insurance-product-card-wrapper/insurance-product-card-wrapper';
import ImageContent from '../../components/image-content/image-content';
import InsuranceStickyWidget from '../../components/insurance-sticky-widget/insurance-sticky-widget';
import InsuranceSummaryTableWrapper from '../../components/insurance-summary-table-wrapper/insurance-summary-table-wrapper';
import JumpLinkNav from '../../components/jump-link-nav/jump-link-nav';
import LabeledC3Chart from '../../components/labeled-c3-chart/labeled-c3-chart';
import LastChance from '../../components/last-chance/last-chance';
import LastUpdate from '../../components/last-update/last-update';
import LifeInsuranceQuotesWrapper from '../../components/life-insurance-quotes-wrapper/life-insurance-quotes-wrapper';
import MarketplaceProductCard from '../../components/marketplace-product-card/marketplace-product-card';
import MarketplaceThirdPartyEmbedWrapper from '../../components/marketplace-third-party-embed/marketplace-third-party-embed';
import NpsCrmEmail from '../../components/nps-crm-email/nps-crm-email';
import Paragraph from '../../components/paragraph/paragraph';
import PasswordLock from '../../components/navigate-toggle/password-lock/password-lock';
import OurValues from '../../components/our-values/our-values';
import QueryParamManager from '../../containers/query-param-manager/query-param-manager';
import QueryParamSection from '../../containers/query-param-section/query-param-section';
import RentersInsuranceEntryPointWrapper from '../../components/renters-insurance-entry-point-wrapper/renters-insurance-entry-point-wrapper';
import RowTwoCol from '../../components/row-two-col/row-two-col';
import RowTwoColOld from '../../components/row-two-col-old/row-two-col-old';
import ScreenSizeConditional from '../../containers/screen-size-conditional/screen-size-conditional';
import ScrollControl from '../../components/scroll-control/scroll-control';
import Splash from '../../components/splash/splash';
import StandardHero from '../../components/standard-hero/standard-hero';
import StickyContainerWrapper from '../../components/sticky-container-wrapper/sticky-container-wrapper';
import Story from '../../containers/story/story';
import StickyHeader from '../../components/sticky-header/sticky-header';
import StoryBlock from '../../components/story-block/story-block';
import StoryCards from '../../components/story-cards/story-cards';
import SweepstakesForm from '../../components/sweepstakes-form/sweepstakes-form';
import TermsTable from '../../components/terms-table/terms-table';
import ThreeSteps from '../../components/three-steps/three-steps';
import ThirdPartyEmbed from '../../components/third-party-embed/third-party-embed';
import ThreeSteps2 from '../../components/three-steps-2/three-steps-2';
import TileCarousel from '../../components/tile-carousel/tile-carousel';
import TickerTape from '../../components/ticker-tape/ticker-tape';
import UniversalBackgroundImage from '../../components/universal-background-image/universal-background-image';
import UniversalAuthButton from '../../components/universal-auth-button/universal-auth-button';
import UniversalButton from '../../components/universal-button/universal-button';
import UniversalContainer from '../../components/universal-container/universal-container';
import UniversalImage from '../../components/universal-image/universal-image';
import UniversalMedia from '../../components/universal-media/universal-media';
import UniversalProductTable from '../../components/universal-product-table/universal-product-table';
import UniversalText from '../../components/universal-text/universal-text';
import VideoEmbed from '../../components/video-embed/video-embed';
import ZigZag from '../../components/zig-zag/zig-zag';

/**
 * Component name associations on landing page client components.
 */
const LPC_COMPONENTS = {
  [ROW]: () => Row,
  [TEXTBOX]: () => TextBox,
  [VERTICALSPACER]: () => VerticalSpacer,
  [PAGE]: () => Page,
  [STANDARDPRODUCTTABLE]: () => StandardProductTable,
  [ABOUT]: () => About,
  [ABTESTWRAPPER]: () => ABTestWrapper,
  [APPROW]: () => AppRow,
  [AUDIOEMBED]: () => AudioEmbed,
  [ARTICLEHEROWRAPPER]: () => ArticleHeroWrapper,
  [AUTOINSURANCEENTRYPOINTWRAPPER]: () => AutoInsuranceEntryPointWrapper,
  [AUTOINSURANCEQUOTESWRAPPER]: () => AutoInsuranceQuotesWrapper,
  [AWARDSBADGEDROPDOWN]: () => AwardsBadgeDropdown,
  [AWARDSHERO]: () => AwardsHero,
  [AWARDSHERO2023]: () => AwardsHero2023,
  [AWARDSNAVIGATION]: () => AwardsNavigation,
  [AWARDTABLE]: () => AwardTable,
  [BACKTOTOP]: () => BackToTop,
  [BOXTABLE]: () => BoxTable,
  [BORDERBANNER]: () => BorderBanner,
  [BRANDHEADER]: () => BrandHeader,
  [BRANDEDARTICLECALCULATOR]: () => BrandedArticleCalculator,
  [BRANDEDHERO]: () => BrandedHero,
  [BULLETEDLIST]: () => BulletedList,
  [C3CHART]: () => C3Chart,
  [CALCULATOR]: () => Calculator,
  [CATEGORYTILES]: () => CategoryTiles,
  [CDSPRODUCTTABLE]: () => CdsProductTable,
  [CDSFILTERS]: () => CdsFilters,
  [CENTEREDHERO]: () => CenteredHero,
  [CHARTSECTION]: () => ChartSection,
  [COLLAPSIBLEPARAGRAPH]: () => CollapsibleParagraph,
  [CREDITCARDTABLE]: () => CreditCardTable,
  [CTABOX]: () => CtaBox,
  [DISCLOSURE]: () => Disclosure,
  [DIVIDER]: () => Divider,
  [EDITABLEBULLETEDLIST]: () => EditableBulletedList,
  [EDITABLEFLOW]: () => EditableFlow,
  [EDITABLEFLYOUTHEADER]: () => EditableFlyOutHeader,
  [EDITABLEINTERESTCALCULATOR]: () => EditableInterestCalculator,
  [EDITABLELOGOSALAD]: () => EditableLogoSalad,
  [EDITABLEPANELGROUP]: () => EditablePanelGroup,
  [EDITABLEPRODUCTTABLE]: () => EditableProductTable,
  [EDITORCONTROL]: () => EditorControl,
  [EXPANDINGPRODUCTTABLE]: () => ExpandingProductTable,
  [FEATUREBAR]: () => FeatureBar,
  [FILTERS]: () => Filters,
  [FLEXCARD]: () => FlexCard,
  [FLEXCARDV2]: () => FlexCardV2,
  [FEATUREDSTORY]: () => FeaturedStory,
  [GLOBALNAV]: () => GlobalNav,
  [GRIDFORM]: () => GridForm,
  [HOMEINSURANCEENTRYPOINTWRAPPER]: () => HomeInsuranceEntryPointWrapper,
  [HORIZONTALBANNER]: () => HorizontalBanner,
  [HEROLANDSCAPEVIDEO]: () => HeroLandscapeVideo,
  [HEROVIDEO]: () => HeroVideo,
  [ICONHEADER]: () => IconHeader,
  [IMAGE]: () => Image,
  [IMAGECONTENT]: () => ImageContent,
  [INSURANCEPRODUCTCARDWRAPPER]: () => InsuranceProductCardWrapper,
  [INSURANCESTICKYWIDGET]: () => InsuranceStickyWidget,
  [INSURANCESUMMARYTABLEWRAPPER]: () => InsuranceSummaryTableWrapper,
  [JUMPLINKNAV]: () => JumpLinkNav,
  [LABELEDC3CHART]: () => LabeledC3Chart,
  [LASTCHANCE]: () => LastChance,
  [LASTUPDATE]: () => LastUpdate,
  [LIFEINSURANCEQUOTESWRAPPER]: () => LifeInsuranceQuotesWrapper,
  [MARKETPLACEPRODUCTCARD]: () => MarketplaceProductCard,
  [MARKETPLACETHIRDPARTYEMBED]: () => MarketplaceThirdPartyEmbedWrapper,
  [NPSCRMEMAIL]: () => NpsCrmEmail,
  [PARAGRAPH]: () => Paragraph,
  [PASSWORDLOCK]: () => PasswordLock,
  [OURVALUES]: () => OurValues,
  [QUERYPARAMMANAGER]: () => QueryParamManager,
  [QUERYPARAMSECTION]: () => QueryParamSection,
  [RENTERSINSURANCEENTRYPOINTWRAPPER]: () => RentersInsuranceEntryPointWrapper,
  [ROWTWOCOL]: () => RowTwoCol,
  [ROWTWOCOLOLD]: () => RowTwoColOld,
  [SCREENSIZECONDITIONAL]: () => ScreenSizeConditional,
  [SCROLLCONTROL]: () => ScrollControl,
  [SPLASH]: () => Splash,
  [STANDARDHERO]: () => StandardHero,
  [STICKYCONTAINERWRAPPER]: () => StickyContainerWrapper,
  [STICKYHEADER]: () => StickyHeader,
  [STORY]: () => Story,
  [STORYBLOCK]: () => StoryBlock,
  [STORYCARDS]: () => StoryCards,
  [SWEEPSTAKESFORM]: () => SweepstakesForm,
  [TERMSTABLE]: () => TermsTable,
  [THIRDPARTYEMBED]: () => ThirdPartyEmbed,
  [THREESTEPS]: () => ThreeSteps,
  [THREESTEPS2]: () => ThreeSteps2,
  [TILECAROUSEL]: () => TileCarousel,
  [TICKERTAPE]: () => TickerTape,
  [UNIVERSALBACKGROUNDIMAGE]: () => UniversalBackgroundImage,
  [UNIVERSALAUTHBUTTON]: () => UniversalAuthButton,
  [UNIVERSALBUTTON]: () => UniversalButton,
  [UNIVERSALCONTAINER]: () => UniversalContainer,
  [UNIVERSALIMAGE]: () => UniversalImage,
  [UNIVERSALMEDIA]: () => UniversalMedia,
  [UNIVERSALPRODUCTTABLE]: () => UniversalProductTable,
  [UNIVERSALTEXT]: () => UniversalText,
  [VIDEOEMBED]: () => VideoEmbed,
  [ZIGZAG]: () => ZigZag,
};

/**
 * Include default Structured Content component names so we can interpret documents that contain generic NW components.
 */
export default {
  ...NW_COMPONENTS,
  ...LPC_COMPONENTS,
};
